export default class GoogleAnalysis {
  static collectPageView(title: string) {
    if (!window.gtag) {
      return;
    }
    window.gtag('js', new Date());
    const locationInfo = window.location;
    window.gtag('config', 'G-4GNCXWRM9B', {
      page_title: title,
      page_location: locationInfo.href
    });
    window.gtag('event', 'page_view', {
      page_title: title,
      page_location: locationInfo.href
    });
  }
}
